import React, { useState } from 'react';
import { Container, Form, Alert } from 'react-bootstrap';
import { contactReasonOptions } from '../../static/common';
import { createContact } from '../../modules/users';
import { Button, Typography } from '@mui/material';
import TextInput from '../elements/TextInput';

const ContactUsForm = () => {
  const [formData, setFormData] = useState({
    reason: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);

    try {
      await createContact(formData);
      setFormData({ reason: '', subject: '', message: '' });
      setStatus({ type: 'success', message: 'Message sent successfully!' });
    } catch (error) {
      setStatus({
        type: 'danger',
        message: error.message || 'Failed to send message.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Typography className="mb-3 text-muted" variant="body2">
          Fill out the form below to reach our support team. We’ll get back to
          you as soon as possible.
        </Typography>
        {/* <Typography className="mb-3 text-muted" variant="body2">
          You can also email us directly at{' '}
          {process.env.REACT_APP_SUPPORT_EMAIL}.
        </Typography> */}

        {status && (
          <Alert variant={status.type} className="mb-2 p-2">
            {status.message}
          </Alert>
        )}

        <Form.Group controlId="reason" className="mb-3">
          <Form.Label className="required">Reason</Form.Label>
          <Form.Select
            name="reason"
            id="reason"
            value={formData.reason}
            onChange={(e) => handleChange('reason', e.target.value)}
            required>
            <option value="">Select a reason</option>
            {contactReasonOptions.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="subject">
          <Form.Label className="required">Subject</Form.Label>
          <TextInput
            id="subject"
            required
            value={formData.subject}
            onChange={handleChange}
            placeholder="Enter subject"
            maxLength={150}
          />
        </Form.Group>

        <Form.Group controlId="message" className="mb-4">
          <Form.Label className="required">Message</Form.Label>
          <TextInput
            id="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message here..."
            maxLength={500}
            rows={3}
            type="textarea"
            required
          />
        </Form.Group>

        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </Button>
      </Form>
    </Container>
  );
};

export default ContactUsForm;
